import { render, staticRenderFns } from "./EmailReminderDialog.vue?vue&type=template&id=45d074bd&scoped=true&"
import script from "./EmailReminderDialog.vue?vue&type=script&lang=js&"
export * from "./EmailReminderDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmailReminderDialog.vue?vue&type=style&index=0&id=45d074bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d074bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VIcon,VProgressCircular})
